export default "__VITE_ASSET__ByrGAbrP__"